/* DO NOT FORGET to add export of this file to /src/store/reducers/index.js */
import * as FP from 'utils/fp-js';

export const spinner = (state, action) =>
  FP.match(action.type)
    .on('SHOW_SPINNER', true)
    .on('HIDE_SPINNER', false)
    .otherwise(state);
